import React from "react";
import { Drawer, Box, Grid, TextField, MenuItem, Checkbox, FormControlLabel, Button } from "@mui/material";
import { SubjectItem } from "./studentSubjectApi";

interface Props {
  open: boolean;
  onClose: () => void;
  studentName: string;
  className: string;
  sectionName: string;
  subjects: SubjectItem[];
  initialSelected: string[];
  initialOptional: string[];
  onSubmit: (data: { subjectIds: string[]; optionalSubjectIds: string[] }) => void;
}

const StudentSubjectForm: React.FC<Props> = ({
  open,
  onClose,
  studentName,
  className,
  sectionName,
  subjects,
  initialSelected,
  initialOptional,
  onSubmit,
}) => {
  const [selected, setSelected] = React.useState<string[]>(initialSelected);
  const [optional, setOptional] = React.useState<string[]>(initialOptional);

  React.useEffect(() => {
    setSelected(initialSelected);
    setOptional(initialOptional);
  }, [initialSelected, initialOptional, open]);

  const toggleOptional = (id: string, checked: boolean) => {
    setOptional((prev) => (checked ? [...prev, id] : prev.filter((x) => x !== id)));
  };

  const handleSave = () => {
    onSubmit({ subjectIds: selected, optionalSubjectIds: optional.filter((id) => selected.includes(id)) });
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 420, p: 2 }}>
        <Box sx={{ fontWeight: 600, mb: 2 }}>Assign Subjects</Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Student" value={studentName} fullWidth disabled />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Class" value={className} fullWidth disabled />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Section" value={sectionName} fullWidth disabled />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Subjects"
              SelectProps={{ multiple: true }}
              value={selected}
              onChange={(e) => setSelected(typeof e.target.value === "string" ? e.target.value.split(",") : (e.target.value as string[]))}
            >
              {subjects.map((s) => (
                <MenuItem key={s.id} value={s.id}>
                  {s.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            {subjects.map((s) => (
              <FormControlLabel
                key={s.id}
                control={
                  <Checkbox
                    checked={optional.includes(s.id)}
                    onChange={(e) => toggleOptional(s.id, e.target.checked)}
                    disabled={!selected.includes(s.id)}
                  />
                }
                label={`${s.name} (Optional)`}
              />
            ))}
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              Save Subjects
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default StudentSubjectForm;
